<script lang="ts" setup>
const props = defineProps<{
  data: { machineryId: string }
}>()
const emit = defineEmits<{
  (e: 'close'): void
}>()

const { $trpc, queryClient, useMutation, makeTrpcErrorToast } = useMutationHelpers()
const notification = useNotification()
const { $i18n } = useNuxtApp()
const createSaleReservationTask = useMutation({
  mutationFn: $trpc.customerModule.machinery.partnerSales.createReservationTask.mutate,
  onError: makeTrpcErrorToast(notification, { description: $i18n.t('customerModule.sale.reservation.notification.error') }),
  onSuccess: async () => {
    await queryClient.invalidateQueries({ queryKey: [CUSTOMER_MODULE_QUERY_KEY, 'saleReservation'] })
    await queryClient.invalidateQueries({ queryKey: ['machines', props.data.machineryId, 'public'] })
    await queryClient.invalidateQueries({ queryKey: [CUSTOMER_MODULE_QUERY_KEY, 'reservation', 'allByMachineryId', props.data.machineryId] })
    notification.success({ title: $i18n.t('customerModule.sale.reservation.notification.success'), duration: 4500 })
    emit('close')
  },
})

const formData = {
  ...props.data,
  subject: '',
  additionalInfo: '',
}

function update({ additionalInfo, subject }: { additionalInfo: string, subject?: string }) {
  return createSaleReservationTask.mutate({ additionalInfo, subject, id: props.data.machineryId })
}
</script>

<template>
  <CustomerModulePopup
    :show="!!data"
    :title="$t('customerModule.sale.reservation.modal.title')"
    @close="$emit('close')"
  >
    <FormKit
      type="form"
      :value="formData"
      :submit-label="$t('button.save')"
      @submit="update"
    >
      <p>{{ $t('customerModule.sale.reservation.creation.hint') }}</p>
      <FormKit
        type="text"
        name="subject"
        :label="$t('comment.subject.label')"
        :placeholder="$t('comment.subject.placeholder')"
      />
      <FormKitTiptapEditor
        name="additionalInfo"
        :label="$t('customerModule.sale.reservation.modal.field.comment')"
        :placeholder="$t('comment.placeholder')"
        validation="required"
      />
      <template #actions>
        <div class="flex gap-4">
          <n-button type="primary" attr-type="submit">
            {{ $t('customerModule.button.send') }}
          </n-button>
          <n-button @click="$emit('close')">
            {{ $t('customerModule.button.cancel') }}
          </n-button>
        </div>
      </template>
    </FormKit>
  </CustomerModulePopup>
</template>
